export const TimeCellRenderer = (params) => {
    return params?.value ? new Date(params?.value).toLocaleTimeString() : null;
};
